class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.hoverOpenTimer = null;
    this.hoverCloseTimer = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;

    clearTimeout(this.hoverCloseTimer);
    clearTimeout(this.hoverOpenTimer);

    this.hoverOpenTimer = setTimeout(() => {
      document.querySelectorAll('header-menu > details[open]').forEach((details) => {
        if (details === this.mainDetailsToggle) return;
        details.removeAttribute('open');
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });

      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }, 90);
  }

  onMouseLeave() {
    if (!this.hoverMediaQuery.matches) return;

    clearTimeout(this.hoverOpenTimer);
    clearTimeout(this.hoverCloseTimer);

    this.hoverCloseTimer = setTimeout(() => {
      if (!this.matches(':hover')) this.close();
    }, 220);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
